import { Stack, Typography } from "@mui/material";
import ActionModuleEditor from "./ActionModuleEditorFrame";
import { useNavigate, useParams } from "react-router-dom";
import { useLocale } from "../../../hooks/UseLocale";
import { useTranslation } from "react-i18next";

export default function NewActionModuleEditorPage() {
    const { t } = useTranslation();
    const { companyId } = useParams();
    const locale = useLocale();
    const navigate = useNavigate();

    return <Stack style={{ height: "calc(100vh - 144px)", boxSizing: "border-box" }}>
        <Typography variant="h3">{t("actionModuleEditor.newActionModule")}</Typography>

        <ActionModuleEditor
            companyId={Number(companyId)}
            isNew={true}
            onSaved={() => navigate(`/${locale}/superadminarea/actionModules`)}
            onDeleted={() => navigate(`/${locale}/superadminarea/actionModules`)} />
    </Stack>
}